import { mergeClassnames } from '@heathmont/moon-core-tw';
import { rem } from '@heathmont/moon-utils';
import useNewThumbnailsEnabled from '~/client/hooks/feature/useNewThumbnailsEnabled';
import useAgentData from '~/client/hooks/useAgentData';

type Props = { width: number; isGridVisible?: boolean };

const GamesContainer: FC<Props> = ({ children, isGridVisible, width }) => {
  const newThumbsEnabled = useNewThumbnailsEnabled();
  const { isMobile } = useAgentData();
  const gridTemplateColumns =
    isMobile && width && !newThumbsEnabled
      ? `repeat(auto-fill, minmax(${rem(width)}, 1fr))`
      : undefined;
  return (
    <div
      className={mergeClassnames(
        'block grid-cols-[repeat(2,1fr)] gap-4 md:grid-cols-[repeat(4,1fr)] xl:grid-cols-[repeat(5,1fr)] 2xl:grid-cols-[repeat(6,1fr)]',
        isGridVisible && 'grid',
        newThumbsEnabled &&
          'gap-x-2 gap-y-3 sm:gap-4 grid-cols-[repeat(auto-fill,minmax(5.5rem,1fr))] xxsm:grid-cols-[repeat(3,1fr)] lg:grid-cols-[repeat(5,1fr)] 2xl:grid-cols-[repeat(7,1fr)]',
      )}
      style={{ gridTemplateColumns }}
    >
      {children}
    </div>
  );
};

export default GamesContainer;
